import clsx from "clsx";
import { Button as AriaButton, Label as AriaLabel } from "react-aria-components";

import { InfoIcon } from "@/assets/icons/general/Info";
import { Tooltip } from "@/components/ui/overlays/Tooltip/Tooltip";
import { Typography } from "@/components/ui/text/Typography/Typography";

export type InputHeaderProps = {
  label: string;
  tooltipText?: string;
  helperText?: string;
  required?: boolean;
  rightContent?: React.ReactNode;
  hideLabels?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  hideLabel?: boolean;
};

export const InputHeader = ({
  label,
  tooltipText,
  helperText,
  required,
  rightContent,
  hideLabels,
}: InputHeaderProps) => {
  return (
    <div className={clsx(hideLabels && "hidden")}>
      <div className="flex items-start justify-between">
        <div>
          <div className="flex items-start gap-1">
            <AriaLabel className="flex items-start">
              <Typography
                as="span"
                size="body-paragraph-xs"
                variant="prominent-1"
                className="font-weight-500 text-body-paragraph-xs text-secondary-100"
              >
                {label}
              </Typography>

              {required && (
                <Typography
                  as="span"
                  size="labels-xs"
                  variant="prominent-1"
                  className="text-danger-200 text-labels-xs"
                >
                  *
                </Typography>
              )}
            </AriaLabel>

            {tooltipText && (
              <Tooltip text={tooltipText}>
                {/* needs to be a button; tooltips are not allowed on unfocusable elements */}
                <AriaButton>
                  <InfoIcon
                    className="h-6 w-6 text-secondary-50"
                    tabIndex={0}
                  />
                </AriaButton>
              </Tooltip>
            )}
          </div>
        </div>
        {rightContent}
      </div>

      {helperText && (
        <Typography
          slot="description"
          size="labels-lg"
          className="text-secondary-200"
        >
          {helperText}
        </Typography>
      )}
    </div>
  );
};
